module.exports = __webpack_public_path__ + "2021525:777057f5211ffb5bd912/img/v2_MM_GROUP_SHOT-2x.d924515.jpg";